import { PInvite } from '../mdl/p-invite';
import { $analytics } from '../y/analytics';
import { $api } from '../y/api';
import { $http } from '../y/http';
import { YId } from '../y/types';

export interface MEInviteContact {
    email: string;
    name?: string;
}

export function meInvitesGet() {
    return $api.GET<PInvite[]>('me/invites');
}

export function meInvitesSend(contacts: MEInviteContact[], flow: 'gmail' | 'outlook' | 'field') {
    return $api.POST('me/invite', { contacts }).then(() => {
        $analytics.track('Invited friend', { count: contacts.length, flow: flow });
    });
}

export function meInviteResend(id: YId) {
    return $api.POST(`me/invite/${id}/resend`);
}

// export function getGoogleContacts(token: string)
// {
//     return $http.POST<any>('/api/v1/google/contacts', { token: token });
// }

export function getOutlookContacts(token: string) {
    return $http.POST<any>('/api/v1/microsoft/contacts', { token: token });
}
